<template>
    <div class="user">
        <!--搜索表单-->
        <div class="common-seach-wrap"> </div>
        <div class="table-wrap">
            <el-table v-loading="loading" :data="tableData" style="width: 100%">
                <el-table-column prop="cooperate_id" label="ID" width="100"></el-table-column>
                <el-table-column prop="cooperate_type_name" label="合作类型"></el-table-column>
                <el-table-column prop="info_type_name" label="类型"></el-table-column>
                <el-table-column prop="name" label="单位名称/姓名"></el-table-column>
                <el-table-column prop="phone" label="手机号码"></el-table-column>

                <el-table-column prop="status_text" label="审核状态" width="70">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0" class="red">待审核</span>
                        <span v-if="scope.row.status == 1" class="green">通过</span>
                        <span v-if="scope.row.status == -1" class="gray">未通过</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="90">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="editClick(scope.row)">审核</el-button>
                        <el-button type="text" size="small" @click="deleteClick(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--分页-->
            <div class="pagination">
                <el-pagination
                    background
                    :current-page="curPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="totalDataNumber"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import PlatformActivityApi from "@/api/platformactivity.js";
    export default {
        components: {
        },
        data() {
            return {
                /*分类*/
                categoryData: [],
                /*表单数据*/
                tableData: [],
                /*是否打开添加弹窗*/
                open_add: false,
                /*是否打开编辑弹窗*/
                open_edit: false,
                /*当前编辑的对象*/
                userModel: {},
                commentData: [],
                loading: true,
                pageSize: 20,
                totalDataNumber: 0,
                curPage: 1,
            };
        },
        created() {
            /*获取平台活动列表*/
            this.getData();
        },
        methods: {
            /*获取平台活动列表*/
            getData() {
                let self = this;
                let Params = {};
                Params.page = self.curPage;
                PlatformActivityApi.cooperate.list(Params, true)
                    .then((data) => {
                        self.loading = false;
                        self.tableData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                    })
                    .catch((error) => {
                        self.loading = false;
                    });
            },

            /*选择第几页*/
            handleCurrentChange(val) {
                this.curPage = val;
                this.loading = true;
                this.getData();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.getData();
            },


            /*编辑活动*/
            editClick(row) {
                this.$router.push({
                    path: "/platformactivity/cooperate/edit",
                    query: {
                        cooperate_id: row.cooperate_id
                    }
                });
            },

            /*删除*/
            deleteClick(row) {
                let self = this;
                self.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        PlatformActivityApi.cooperate.delGoods(
                            {
                                cooperate_id: row.cooperate_id
                            },
                            true
                        )
                            .then((data) => {
                                if (data.code == 1) {
                                    self.$message({
                                        message: "恭喜你，商品删除成功",
                                        type: "success"
                                    });
                                    this.onSubmit();
                                } else {
                                    self.$message.error("错了哦，这是一条错误消息");
                                }
                            })
                            .catch((error) => {});
                    })
                    .catch(() => {});
            },



            stateSet(e, id) {
                let self = this;
                PlatformActivityApi.cooperate.stateSet({
                    cooperate_id: id,
                    status: e,
                    r_msg: '',
                }).then((data) => {
                    self.$message({
                        message: data.msg,
                        type: "success"
                    });
                    // self.getData();
                });
            }

        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/platformactivity/cooperate/index.vue